import { decodeJwt } from "jose";

import { TokenTypeEnum } from "../enums/token-type.enum";

export class Token {
  public readonly expiresAt: number;

  constructor(
    public readonly value: string,
    public readonly type: TokenTypeEnum
  ) {
    const exp = decodeJwt(value).exp || 0;
    this.expiresAt = exp;
  }

  toString() {
    return this.value;
  }

  isExpired() {
    return this.expiresAt * 1000 < Date.now();
  }
}

export class RefreshToken extends Token {
  constructor(public readonly value: string) {
    super(value, TokenTypeEnum.REFRESH);
  }
}

export class AccessToken extends Token {
  constructor(public readonly value: string) {
    super(value, TokenTypeEnum.ACCESS);
  }
}

export class InvitationToken extends Token {
  constructor(public readonly value: string) {
    super(value, TokenTypeEnum.INVITATION);
  }
}

export class PasswordResetToken extends Token {
  constructor(public readonly value: string) {
    super(value, TokenTypeEnum.PASSWORD_RESET);
  }
}

export class ApiKey extends Token {
  constructor(public readonly value: string) {
    super(value, TokenTypeEnum.API_KEY);
  }
}
